import React from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";
import PieChart from "../Charts/PieChart";
import BarChart from "../Charts/BarChart";
import LineChart from "../Charts/LineChart";
import TechPrepPortalMgtBreadCrumbs from "../../Layout/TechPrepPortalMgtBreadCrumbs";

const TechPrepCoordinatorDash = () => {
  return (
    <Grid container spacing={3} sx={{ padding: 3 }}>
      <Grid item xs={12} md={12} mt={4}>
        <h1>TechPrep Coordinator</h1>
      </Grid>
      <Grid item xs={12} md={12}>
        <TechPrepPortalMgtBreadCrumbs />
      </Grid>
      <Grid item xs={12} md={4}>
        <Card>
          <CardHeader title="Pie Chart" />
          <CardContent>
            <PieChart />
          </CardContent>
          <CardActions>
            <Button size="small">Show More</Button>
          </CardActions>
        </Card>
      </Grid>
      <Grid item xs={12} md={4}>
        <Card>
          <CardHeader title="Bar Chart" />
          <CardContent>
            <BarChart />
          </CardContent>
          <CardActions>
            <Button size="small">Show More</Button>
          </CardActions>
        </Card>
      </Grid>
      <Grid item xs={12} md={4}>
        <Card>
          <CardHeader title="Line Chart" />
          <CardContent>
            <LineChart />
          </CardContent>
          <CardActions>
            <Button size="small">Show More</Button>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};

export default TechPrepCoordinatorDash;
